module.exports = __webpack_public_path__ + "static/lost-prayer-to-the-sacred-winds-a913b88d4ec017e5fe98ae37107c9a76.png";